module.exports = __webpack_public_path__ + "media/images/content-pillar-calendar-891e2838.png";